import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';

import classNames from 'classnames';
import StarIcon, { StarIconProps } from '../StarIcon';
import getClassNames from '../../utils/getClassNames';

import styles from './Rating.module.scss';

export type RatingProps = {
  rating: number;
  withTextRating?: boolean;
  size?: StarIconProps['size'];
  theme?: StarIconProps['theme'];
  feature?: StarIconProps['feature'];
  /** Removes padding */
  fullHeight?: boolean;
};

const textRatings = [
  '',
  'rating--text-rating--terrible',
  'rating--text-rating--bad',
  'rating--text-rating--okay',
  'rating--text-rating--good',
  'rating--text-rating--awesome',
];

const Rating: FC<RatingProps> = ({
  rating,
  withTextRating = false,
  size,
  theme,
  feature,
  fullHeight,
}) => {
  const [t] = useTranslation('common');

  return (
    <div className={getClassNames(styles, 'root', feature)}>
      {withTextRating && (
        <div className={getClassNames(styles, 'textRating', feature)}>
          {t(textRatings[rating])}
        </div>
      )}
      <div className={getClassNames(styles, 'stars', classNames({ fullHeight }))}>
        {Array.from({ length: 5 }, (_, i) => {
          const empty = i >= rating;
          const half = rating > i && rating < i + 0.85;
          return (
            <StarIcon
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              half={half}
              empty={empty}
              feature={feature}
              theme={theme}
              size={size}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Rating;
